import React from 'react';


const newAddressContext = React.createContext({});

const { Provider, Consumer } = newAddressContext;

export const NewAddressContextProvider = Provider;

export const NewAddressContextConsumer = Consumer;

export const NewAddressContext = newAddressContext;
